import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import Lottie from 'lottie-react';

import scrolldown from '../../../assets/animation/scrolldown.json';
import useResize from '../../../hooks/useResize';
import useScroll from '../../../hooks/useScroll';
import { getTagActionName } from '../../../utils/analytics';

import './styles.scss';

const ScrollDownAnimated = () => {
  const [hideScrollDown, setHideScrollDown] = useState(false);
  const [,, height] = useResize();
  const { scrollTop } = useScroll();

  const scrollTo = () => {
    const element = document.querySelector('.section-plans');
    element.scrollIntoView({ behavior: 'smooth' });
    getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Click', 'Scroll down', 'trackAction');
  };

  useEffect(() => {
    setHideScrollDown(scrollTop > 0);
  }, [scrollTop]);

  const lottieRef = useRef();

  useEffect(() => {
    if (lottieRef) {
      lottieRef.current.setSpeed(1.5);
    }
  }, [lottieRef]);

  return (
    <div className={`scrolldown ${!hideScrollDown ? 'flex' : ''} ${height >= 768 ? 'is-large' : ''}`} onClick={scrollTo}>
      <div className="scrolldown_source">
        <Lottie
          lottieRef={lottieRef}
          animationData={scrolldown}
          autoplay
        />
      </div>
      <div className="scrolldown_tooltip">
        <div className="scrolldown_message">
          Conoce más
        </div>
      </div>
    </div>
  );
};

ScrollDownAnimated.propTypes = {
  authoring: PropTypes.shape({
    product: PropTypes.string,
    rangeScrollDesktop: PropTypes.number,
    rangeScrollMobile: PropTypes.number,
  }).isRequired,
};

export default ScrollDownAnimated;
